import { differenceInDays } from 'date-fns'

/**
 * Computes an ISO 8601 day-based duration string from two dates.
 */
export const computeDurationFromDates = (
  startDate: Date,
  endDate: Date
): string => `P${differenceInDays(endDate, startDate)}D`
